// extracted by mini-css-extract-plugin
module.exports = {"PlainFeature":"wn_a bht_b"};